export const unique = <T>(array: T[], key?: string, preferLast = false): T[] => {
  if (!key) return Array.from(new Set(array));

  const seen = new Set();
  const out: T[] = [];

  if (preferLast) {
    array.reverse();
  }

  array.forEach(item => {
    const keyValue = item[key];
    if (!seen.has(keyValue)) {
      seen.add(keyValue);
      out.push(item);
    }
  });

  if (preferLast) {
    out.reverse();
  }

  return out;
};
